import * as React from "react";

import { Button } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { Box, Popover, Typography } from "@mui/material";
import HelpCenterOutlinedIcon from "@mui/icons-material/HelpCenterOutlined";

import SupportEmailLink from "./SupportEmailLink";
import CallIcon from "../../assets/phone_in_talk.svg";
import {
  ATTORNEY_SUPPORT_PHONE,
  ATTORNEY_SUPPORT_PHONE_FORMAT,
  PROPERTY_RISK_SUPPORT_PHONE,
  PROPERTY_RISK_SUPPORT_PHONE_FORMAT,
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
  SUPPORT_PHONE_FORMAT,
} from "../helpers/constants";

const SERVER = process.env.REACT_APP_SERVER;

const callNowBtn = {
  // backgroundColor: "#0395FF",
  backgroundColor: "#005B9E",
  boxShadow: "none",
  borderRadius: "20px",
  padding: "6px 30px",
  fontWeight: "600",
  fontSize: "12px",
  lineHeight: "17px",
  textTransform: "uppercase",
  color: "#FFFFFF",
  border: "none",
  "&:hover": {
    backgroundColor: "#0395FF",
  },
};

const contactsValueStyle = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "28px",
  color: "#15be53",
  textDecoration: "none",
  padding: "0 5px",
};

const CallUsNow = ({
  type = "text",
  anchorOrigin,
  transformOrigin,
  renderText,
  tryPage,
  hideEmail = false,
  renderButtonText = "Call us now",
  btn_class = "",
  isAttorneyRoute = false,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (tryPage) {
      if (SERVER === "production") {
        if (window && window.gtag) {
          window.gtag("event", "conversion", {
            send_to: "AW-11111779525/PC7-CMvymqwYEMWZwbIp",
            value: 1.0,
            currency: "USD",
            // 'event_callback': callback
          });
        }
      }
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const Callto = ({ phone, children }) => {
    return (
      <a style={contactsValueStyle} href={`tel:${phone}`}>
        {children}
      </a>
    );
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      {type === "text" ? (
        renderText ? (
          isAttorneyRoute ? (
            <span aria-describedby={id}>
              <a
                style={contactsValueStyle}
                href={`tel:${ATTORNEY_SUPPORT_PHONE}`}
              >
                {renderText}
              </a>
            </span>
          ) : (
            <span aria-describedby={id} onClick={handleClick}>
              {renderText}
            </span>
          )
        ) : (
          <button
            aria-describedby={id}
            className={`${btn_class ? btn_class : "m-2"}`}
            variant="contained"
            style={{
              backgroundColor: tryPage ? "#02a8e2" : "#005B9E",
              boxShadow: "none",
              borderRadius: "20px",
              padding: "6px 30px",
              fontWeight: "600",
              fontSize: "12px",
              lineHeight: "17px",
              textTransform: "uppercase",
              color: "#FFFFFF",
              border: "none",
              "&:hover": {
                backgroundColor: "#0395FF",
              },
            }}
            onClick={handleClick}
          >
            {renderButtonText}
          </button>
        )
      ) : type === "help" ? (
        <HelpCenterOutlinedIcon
          onClick={handleClick}
          sx={{ color: "#9CB8A6", fontSize: "30px", ms: 1, cursor: "pointer" }}
        />
      ) : type === "attorney" ? (
        <a style={contactsValueStyle} href={`tel:${ATTORNEY_SUPPORT_PHONE}`}>
          <button
            aria-describedby={id}
            className={`${btn_class ? btn_class : "m-2"}`}
            variant="contained"
            style={{
              backgroundColor: "#005B9E",
              boxShadow: "none",
              borderRadius: "20px",
              padding: "6px 30px",
              fontWeight: "600",
              fontSize: "12px",
              lineHeight: "17px",
              textTransform: "uppercase",
              color: "#FFFFFF",
              border: "none",
              "&:hover": {
                backgroundColor: "#0395FF",
              },
            }}
            //onClick={handleClick}
          >
            Call us now at {ATTORNEY_SUPPORT_PHONE_FORMAT}
          </button>
        </a>
      ) : type === "investor" ? (
        <Box className="contact_section">
          <div className="d-none d-md-block">
            <Typography className="inv_help_texts">Need help?</Typography>
            <Typography className="contact_texts">
              Call us at{" "}
              <Callto phone={`${PROPERTY_RISK_SUPPORT_PHONE}`}>
                <span className="inv_phone_number">
                  {PROPERTY_RISK_SUPPORT_PHONE_FORMAT}
                </span>
              </Callto>
            </Typography>
          </div>
          <div className="MobAction_btn ms-auto d-flex flex-row d-md-none">
            <a
              style={contactsValueStyle}
              href={`tel:${PROPERTY_RISK_SUPPORT_PHONE}`}
            >
              <Button className="mx-1 call_btn inv_callus_btn" variant="link">
                <LazyLoadImage
                  src={CallIcon}
                  width="24px"
                  height="24px"
                  alt="Phone Talk"
                />
              </Button>
            </a>
          </div>
        </Box>
      ) : (
        <img
          aria-describedby={id}
          onClick={handleClick}
          src={CallIcon}
          alt="Calling"
          style={{ cursor: "pointer" }}
        />
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        sx={{ zIndex: 111111111 }}
      >
        {!hideEmail && (
          <Typography
            sx={{ minHeight: "20px", minWidth: "35px" }}
            px={1}
            my={1}
          >
            Email :
            <SupportEmailLink
              email={SUPPORT_EMAIL}
              text={SUPPORT_EMAIL}
              sx={contactsValueStyle}
            />
          </Typography>
        )}
        <Typography sx={{ minHeight: "20px", minWidth: "35px" }} px={1} my={1}>
          Phone :{" "}
          <Callto phone={`${SUPPORT_PHONE}`}>{SUPPORT_PHONE_FORMAT}</Callto>
        </Typography>
      </Popover>
    </>
  );
};

export default CallUsNow;
